<app-user-menu [orgId]="orgId" *ngIf="menu === 'user'"></app-user-menu>
<app-vss-organization-menu [id]="orgId" *ngIf="menu === 'vss'"></app-vss-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <div class="row">
        <div class="col">
            <section class="mb-5">
                <h4 class="border-bottom pb-2 color-primary">{{'USER.NEWS.image' | translate}}
                    <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                        {{'USER.NEWS.imageHelpText' | translate}}
                    </small>
                </h4>
                <div class="row">
                    <div class="col-12 col-sm-6 text-center">
                        <ng-container *ngIf="imagePath; else elseTemplate">
                            <img [src]="imagePath" (click)="openLightbox()" class="img-thumbnail" style="height: 200px">
                            <div class="text-center mt-1" *ngIf="dynamicData.file">
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="deleteImage()">{{'GENERAL.delete' | translate}}</button>
                            </div>
                        </ng-container>
                        <ng-template #elseTemplate>
                            <ng-container *ngIf="menu === 'vss'; else elseTemplate">
                                <img [src]="'assets/images/standard-picture-vss.png'" class="img-thumbnail"
                                    style="height: 200px">
                            </ng-container>
                            <ng-template #elseTemplate>
                                <img [src]="(dynamicData.organizationTypeId == 1 ? 'assets/images/lidonews-placeholder.jpg' : 'assets/images/museumnews-placeholder.jpg')"
                                    class="img-thumbnail" style="height: 200px">
                            </ng-template>
                        </ng-template>
                    </div>
                    <div class="col-12 col-sm-6">
                        <p class="form-text text-muted mb-0">
                            {{'USER.NEWS.uploadHelpText' | translate}}
                        </p>
                        <div class="custom-file mb-2">
                            <input type="file" class="form-control form-control-sm custom-file-input" id="customFile"
                                (change)="handleImageFileInput($event)" accept=".gif,.jpg,.jpeg,.png">
                            <label class="form-label" for="customFile"> {{'USER.NEWS.browse' | translate}}
                            </label>
                            <small class="help-text text-danger" *ngIf="fileSizeError">
                                {{'USER.NEWS.fileSizeError' | translate}}
                            </small>
                        </div>
                        <button type="button" class="btn btn-outline-primary btn-sm float-right"
                            (click)="onUploadImageButtonClick()"> {{'USER.NEWS.uploadImage' | translate}} </button>
                    </div>
                </div>
            </section>
            <section class="mb-5">
                <h4 class="border-bottom pb-2 color-primary">{{'USER.NEWS.text' | translate}}
                    <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                        {{'USER.NEWS.textHelpText' | translate}}
                    </small>
                </h4>
                <div class="row">
                    <div class="col">
                        <div class="form-group editor-container">
                            <span class="remaning" *ngIf="remainingText_de">{{remainingText_de}} / {{maxLengthText}} max</span>
                            <label>{{'GENERAL.german' | translate}}</label>
                            <quill-editor id="description_de" name="description_de" [(ngModel)]="dynamicData.comment_de"
                                [styles]="{height: '250px'}" (onEditorChanged)="changedEditor('de', $event)" [maxLength]="maxLengthText">
                            </quill-editor>
                            <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                    [icon]="icons['faLink']"></fa-icon>
                                {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                            <!-- <textarea class="form-control form-control-sm" id="description_de" name="description_de"
                                [(ngModel)]="dynamicData.comment_de" rows="8"></textarea> -->
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group editor-container">
                            <span class="remaning" *ngIf="remainingText_it">{{remainingText_it}} / {{maxLengthText}} max</span>
                            <label>{{'GENERAL.italian' | translate}}</label>
                            <quill-editor id="description_it" name="description_it" [(ngModel)]="dynamicData.comment_it"
                                [styles]="{height: '250px'}" (onEditorChanged)="changedEditor('it', $event)" [maxLength]="maxLengthText">
                            </quill-editor>
                            <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                    [icon]="icons['faLink']"></fa-icon>
                                {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                            <!-- <textarea class="form-control form-control-sm" id="description_de" name="description_de"
                                [(ngModel)]="dynamicData.comment_it" rows="8"></textarea> -->
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group editor-container">
                            <span class="remaning" *ngIf="remainingText_en">{{remainingText_en}} / {{maxLengthText}} max</span>
                            <label>{{'GENERAL.'+(menu === 'vss' ? 'ladin' : 'english') | translate}}</label>
                            <quill-editor id="description_en" name="description_en" [(ngModel)]="dynamicData.comment_en"
                                [styles]="{height: '250px'}" (onEditorChanged)="changedEditor('en', $event)" [maxLength]="maxLengthText">
                            </quill-editor>
                            <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                    [icon]="icons['faLink']"></fa-icon>
                                {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                            <!-- <textarea class="form-control form-control-sm" id="description_en" name="description_en"
                                [(ngModel)]="dynamicData.comment_en" rows="8"></textarea> -->
                        </div>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col text-end">
                        <button type="button" class="btn btn-outline-primary btn-sm float-right"
                            (click)="onCommentSaveButtonClick()">{{'GENERAL.save' | translate}}</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="row">
        <div class="col text-center">
            <strong class="text-warning">
                {{'USER.NEWS.warningMsg' | translate}}
            </strong>
        </div>
    </div>
</div>
<app-toast></app-toast>
